import React from 'react';

import { FontAwesomeIcon as FA } from '@fortawesome/react-fontawesome';
import { faEye } from '@fortawesome/free-solid-svg-icons/faEye';
import { faEyeSlash } from '@fortawesome/free-solid-svg-icons/faEyeSlash';

import ListResource from './ListResource.jsx';
import ListCtrlActivates from './ListCtrlActivates.jsx';

const api = '/api/core/arScenes';

const ListArScenes = () => (
  <ListResource
    {...{
      searchable: true,
      api,
      sort: { order: 1 },
      cols: [
        { key: 'name', sortable: true },
        { key: 'order', sortable: true },
        {
          key: 'active',
          getter(v) {
            return (
              <FA icon={v ? faEye : faEyeSlash} />
            );
          },
        },
      ],
    }}
  >
    {({ selected, refresh }) => (
      <ListCtrlActivates
        api={api}
        selected={selected}
        onSuccess={refresh}
      />
    )}
  </ListResource>
);

export default ListArScenes;
